import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "block-in",
  "use": "block-in-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"block-in\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.833 11.667a.833.833 0 100 1.666h9.655l-2.744 2.744a.833.833 0 001.179 1.179l4.166-4.167a.833.833 0 000-1.178l-4.166-4.167a.833.833 0 10-1.179 1.179l2.745 2.744H2.832zm10.834 9.166a.833.833 0 000 1.667H19.5A2.5 2.5 0 0022 20V5a2.5 2.5 0 00-2.5-2.5h-5.833a.833.833 0 000 1.667H19.5c.46 0 .833.373.833.833v15c0 .46-.373.833-.833.833h-5.833z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol